<template>
  <PageBlocked v-if="isBlocked" :blockRole="blockRole"/>
  <div v-else class="d-flex flex-column">

    <FilterChipButtons
        :style="{ marginBottom: !banner ? '20px' : '' }"
        :isButtonActive="isButtonActive"
        :chipsList="chipsList"
        :clearFilter="clearFilter"
        @handleChipClick="handleChipClick"
        :useContentAsKey="true"
    />
    <div v-if="filterModalIsVisible">
      <FilterModal
          :filterModalIsVisible="filterModalIsVisible"
          :currentModalFilter="currentModalFilter"
          :currentModalLabel="currentModalLabel"
          :selectedChips="selectedChips"
          :filters="filters"
          :dateError="date.error"
          :dateOption="date.option"
          :dateRange="date.selectedRange"
          @closeModal="closeModal"
          @applySelection="applySelection"
          @setItem="setItem"
      />
    </div>
    <Banner class="mt-5" v-if="banner && !isLoading" :banner="banner" />
    <v-skeleton-loader
        v-if="isLoading"
        v-bind="attrs"
        max-width="555"
        width="100%"
        type="list-item, list-item-three-line, card-heading"
        class="mt-3"
    />
    <div class="d-flex flex-column" v-else>
      <div class="agenda-page__not-found" v-if="!agendaEvent.length">
        <NewsFeedEmpty
            v-if="!hasSearchText"
            title="Session is empty at the moment."
            description="Check back later."
        />
        <span v-else class="agenda-page__not-found__text">
          No results found
        </span>
      </div>
      <div v-for="{ date, data } in agendaSessions" :key="date">
        <div class="agenda-page__title">
          {{ date }}
        </div>
        <div v-for="(agenda, index) in data" :key="index">
          <AgendaCard :agenda-event="agenda" />
        </div>
      </div>
      <div
          class="d-flex my-9 justify-center home-page__pagination"
          v-if="agendaEvent.length > 0"
      >
        <v-pagination
            color="#F2F2F2"
            :total-visible="10"
            circle
            v-model="filters.page"
            @input="(e) => onPageChange(e)"
            :length="+this.pageCountAgendas"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import AgendaCard from '@/components/Event/AgendaCard'
import NewsFeedEmpty from '@/components/Post/NewsFeedEmpty'
import Dwh from '@/mixins/Dwh'
import EventDescription from '@/components/Event/EventDescription.vue'
import FilterChipButtons from '@/components/FilterChipButtons.vue'
import FilterModal from '@/components/Modals/FilterModal'
import Filter from '@/mixins/Filter'
import Banner from '@/components/Banner'
import Block from '@/mixins/Block.js'
import PageBlocked from '@/components/PageBlocked'

export default {
  name: 'AgendasPage',
  mixins: [Dwh, Filter,Block],
  components: {
    FilterChipButtons,
    EventDescription,
    AgendaCard,
    NewsFeedEmpty,
    FilterModal,
    Banner,
    PageBlocked
  },
  methods: {
    ...mapActions('event', ['getEventTracks', 'clearEventTracks', 'getEvent']),
    ...mapActions('advertisement', ['getBanner', 'clearBanner']),
    ...mapActions('list', ['getSortType']),
    ...mapActions('app', ['setPageTitle']),
  },
  created() {
    if (this.$route.params.id !== undefined) {
      this.getEventTracks({ eventId: this.$route.params.id, page: 1 })
      const bannerQuery = {
        places: ['event_agenda'],
        place_sub_id: this.$route.params.id,
        page: this.filters.page,
      }
      if (this.selectedChips.chapters && this.selectedChips.chapters.length) {
        bannerQuery.chapter_id = this.selectedChips.chapters
      }
      this.getBanner(bannerQuery)
    }
    this.getAgendaEvent(this.requestQuery)
    const triggerPayload = {
      category: 'Content',
      action: this.$route.name === 'event-agenda',
      module: 'Events',
    }
    this.sendTrigger(triggerPayload)
  },
  beforeDestroy() {
    this.clearEventTracks()
    this.clearBanner()
    this.setPageTitle('')

  },
  mounted() {
    this.setPageTitle('Agenda')
  },

  computed: {
    ...mapGetters('event', [
      'isLoading',
      'pageCountAgendas',
      'agendaEvent',
      'eventTracks',
      'event',
    ]),
    ...mapGetters('advertisement', ['banner']),
    ...mapGetters('list', ['sortType']),
    ...mapGetters('app', ['search']),
    hasSearchText() {
      return !!this.search?.trim()
    },
    agendaSessionsBlock() {
      return this.agendaEvent.map((agenda) => {
        if (!agenda || !Array.isArray(agenda.sessionsList)) return null
        const block = agenda.sessionsList.find((b) => b.block_name === 'sessionInfo')
        return block ? block.block_data : null
      })
    },
    agendaSessions() {
      const result = []
      this.agendaSessionsBlock.forEach((event) => {
        const fromDate = new Date(event.events_agenda_from * 1000)
        const month = fromDate.toLocaleString('en-US', { month: 'long' })
        const year = fromDate.getFullYear()
        const day = fromDate.toLocaleString('en-US', { day: 'numeric' })
        const key = `${month} ${day}`
        if (result.length === 0) {
          result.push({
            date: key,
            data: [event],
          })
        } else {
          const lastGroup = result[result.length - 1]
          if (lastGroup.date === key) {
            lastGroup.data.push(event)
          } else {
            result.push({
              date: key,
              data: [event],
            })
          }
        }
      })
      return result.map(({ date, data }) => ({ date, data }))
    },
  },

  data() {
    return {
      pageBlockedName: 'events',
      attrs: {
        elevation: 0,
      },
    }
  },
}
</script>

<style lang="scss">
.agenda-page {
  background: #f1f1f1 !important;
  font-family: 'Inter', sans-serif;
  &__not-found{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 730px;
    &__text{
      font-family: 'Inter', sans-serif;
      font-weight: 700;
      font-size: 16px;
      line-height: 100%;
      letter-spacing: 0;
      text-align: center;
      color: #4a4a4a;
    }
  }

  &__title {
    font-weight: 700;
    font-size: 18px;
    line-height: 100%;
    letter-spacing: 0;
    color: #4a4a4a;
    margin-bottom: 8px;
    margin-top: 20px;
  }

  .post {
    &__search {
      background: white;
      height: 54px;
      border-radius: 10px;
      border: 1px solid rgb(230, 230, 230);
      max-width: 600px;
    }

    @media screen and (max-width: 1264px) {
      &__search {
        max-width: none;
        width: 100%;
      }
    }
  }
}

@media screen and (min-width: 1200px) {
  .agenda-page-container {
    max-width: 100%;
    width: 100%;
  }
}

@media screen and (min-width: 1320px) {
  .agenda-page-container {
    max-width: 600px;
  }
}
</style>

